import React from 'react'

export const LeftContent = ({ title, description, children }) => {
  return (
    <div className="col-md-7 col-sm-12">
      <h2 className="animate__animated animate__fadeInDown">{title}</h2>
      <p className="animate__animated animate__fadeInUp">{description}</p>
      {children}
    </div>
  )
}
